export default __webpack_public_path__ + "static/media/select-level.483db9fc.jpg";